import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { ResetData, UserService } from '../../services/User';

const ResetPassword: React.FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);

  // Extract query parameters from the URL
  const queryParams = new URLSearchParams(location.search);
  const resetData: ResetData = {
    token: queryParams.get('token') || '',
    newPassword: ''
  };

  // Function to check if passwords match
  const validatePasswords = (_: any, value: string) => {
    const password = form.getFieldValue('password');
    if (password !== value) {
      return Promise.reject(new Error('Lozinke nisu iste.'));
    }
    return Promise.resolve();
  };

  // Function to handle form submission
  const resetPassword = async () => {
    try {
      const values = await form.validateFields();
      resetData.newPassword = values.password;

      // Call the API to reset the password
      await UserService.resetPassword(resetData);

      message.success('Uloguj se sa novom lozinkom', 3);
      navigate('/login');
    } catch (err) {
      console.error(err);
      setError('Error resetting password');
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100vh' }}>
      <h2>Change Password</h2>

      <Form form={form} layout="vertical">
        <Form.Item
          label="Password"
          name="password"
          rules={[
            { required: true, message: 'Please enter password' },
            { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d]).{8,}$/, message: 'Password must have an uppercase, lowercase, number, special character and 8 chars' }
          ]}
        >
          <Input.Password placeholder="Lozinka" />
        </Form.Item>

        <Form.Item
          label="Password Confirm"
          name="password_confirm"
          dependencies={['password']}
          rules={[
            { required: true, message: '' },
            { validator: validatePasswords }
          ]}
        >
          <Input.Password placeholder="Password Confirm" />
        </Form.Item>

        {error && <div className="error" style={{ color: 'red' }}>{error}</div>}

        <Form.Item>
          <Button type="primary" onClick={resetPassword} block>
            Change Password
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ResetPassword;
